import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class DeliveryCarService {
  constructor(private http: HttpClientService) {}

  public show(application_id, car_delivery_id = 0, delivery_process_id = 0): Observable<any> {
    const options = {
      params: {
        application_id: application_id,
      },
    };
    return this.http
      .get("/api/delivery_process/" + delivery_process_id + "/car_deliveries/show" + car_delivery_id, options)
      .pipe(tap((_) => console.log("DeliveryCarService.index: Ok.")));
  }

  public update_status(
    { car_delivery_id = undefined, status = undefined, comment = undefined, user_id = undefined },
    delivery_process_id
  ): Observable<any> {
    let options = { car_delivery_id, status, comment, user_id, delivery_process_id };
    return this.http
      .put("/api/delivery_process/" + delivery_process_id + "/car_deliveries/update_status", options)
      .pipe(tap((_) => console.log("DeliveryCarService.update_status: Ok.")));
  }

  public update(
    date_time,
    address_complete,
    comment,
    status,
    user_id,
    car_delivery_id,
    delivery_process_id
  ): Observable<any> {
    let options = {
      date_time,
      address_complete,
      comment,
      status,
      user_id,
      car_delivery_id,
      delivery_process_id,
    };

    return this.http
      .put("/api/delivery_process/" + delivery_process_id + "/car_deliveries/" + car_delivery_id, options)
      .pipe(tap((_) => console.log("DeliveryCarService.update: Ok.")));
  }

  public getDelivery(application_id, car_delivery_id = 0, delivery_process_id = 0): Observable<any> {
    const options = {
      params: { application_id: application_id },
    };
    return this.http
      .get("/api/delivery_process/" + delivery_process_id + "/car_deliveries/delivery", options)
      .pipe(tap((_) => console.log("DeliveryCarService.getDelivery: Ok.")));
  }
}
